//src/pages/Success.js

import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Header from "../components/Header";

const Success = () => {
  const navigate = useNavigate();
  const { service } = useLocation().state || {};
  const deducted = service?.totalDeducted || 297;
  const refundTotal = deducted * 2;

  return (
    <div className="page-wrapper">
      <Header />
      <div className="container py-3">

        {/* Cancel confirmed */}
        <div style={{ textAlign: "center", padding: "20px 0 14px" }}>
          <div style={{
            width: 66, height: 66, background: "#edfaf3", borderRadius: "50%",
            display: "flex", alignItems: "center", justifyContent: "center",
            fontSize: "2rem", margin: "0 auto 12px"
          }}>✅</div>
          <h2 style={{ fontSize: "1.1rem", fontWeight: 700, marginBottom: "6px" }}>Cancel Mukammal</h2>
          <p style={{ fontSize: "0.8rem", color: "#555", lineHeight: 1.55 }}>
            Aap ki service kamyabi se band kar di gayi hai.<br />
            Ab aap se is service ke liye koi charges nahi liye jayenge.
          </p>
        </div>

        {/* Khushkhabri refund card — matches image exactly */}
        <div style={{
          background: "#edfaf3", border: "1.5px solid #a8e6c8",
          borderRadius: "12px", padding: "14px", marginBottom: "16px"
        }}>
          <div style={{ display: "flex", gap: "8px", marginBottom: "12px" }}>
            <span style={{ fontSize: "1.2rem" }}>🎉</span>
            <div>
              <p style={{ fontWeight: 700, fontSize: "0.88rem" }}>Khushkhabri! 🎉</p>
              <p style={{ fontSize: "0.76rem", color: "#2d6a4f", lineHeight: 1.55 }}>
                Kyunke is service ke liye aap se baghair valid consent ke amount liya gaya tha,
                is liye aap ka deducted amount aur hamari taraf se complimentary amount
                (same as deducted amount) refund kar diya jayega.
              </p>
            </div>
          </div>

          {/* Refund summary table */}
          <div style={{ background: "white", borderRadius: "8px", padding: "10px" }}>
            <p style={{ fontWeight: 700, fontSize: "0.82rem", marginBottom: "8px" }}>Refund Summary</p>
            {[
              { label: "Aap ka Deducted Amount", value: `Rs. ${deducted}` },
              { label: "Hamari Taraf se Complimentary", value: `Rs. ${deducted}` },
            ].map((row, i) => (
              <div key={i} style={{ display: "flex", justifyContent: "space-between", fontSize: "0.78rem", padding: "4px 0", borderBottom: "1px dashed #eee" }}>
                <span style={{ color: "#555" }}>{row.label}</span>
                <span style={{ fontWeight: 600 }}>{row.value}</span>
              </div>
            ))}
            <div style={{ display: "flex", justifyContent: "space-between", fontSize: "0.88rem", padding: "8px 0 0", fontWeight: 700 }}>
              <span>Total Refund Amount</span>
              <span style={{ color: "var(--wd-green)" }}>Rs. {refundTotal}</span>
            </div>
          </div>

          <p style={{ fontSize: "0.72rem", color: "#2d6a4f", marginTop: "8px", textAlign: "center" }}>
            Refund 3–5 kaamiabi din mein aap ke account mein bhej diya jayega.
          </p>
        </div>

        <button className="btn-blue" onClick={() => navigate("/thankyou")}>
          Home Par Jayein
        </button>
      </div>
    </div>
  );
};

export default Success;
